import script from "./BlogFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogFooter.vue?vue&type=script&lang=ts&setup=true"

import "./BlogFooter.vue?vue&type=style&index=0&id=5bcd3c18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcd3c18"]])

export default __exports__